import React, { FC } from 'react'

const SingleProduct:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/single-product.png" alt=''/>
        </div>
    </div>
  )
}

export default SingleProduct